// extracted by mini-css-extract-plugin
module.exports = {"toast":"Toast_toast__14S2T"};